import { minimatch } from 'minimatch'

import type { ConfigLayerCapabilityOptions } from './ConfigLayerCapability'
import type { ConfigLayerOptions } from '../ConfigLayer'

export class ConfigLayerCatalog {
  static getLayerFilterArray (capabilityOptions: ConfigLayerCapabilityOptions) {
    // Craft array of match patterns from layerFilter string
    const layerFilterArray = (capabilityOptions.layerFilter || '')
      .split(/\s*;\s*/) // split on semicolon (with potential white-space in between)

      // Create wildcard glob pattern around item for matching. There is a
      // special case for exclude items (with exclamation mark): this needs to be
      // moved to the start of the string! Also, remove whitespace where needed
      // e.g.:
      //   'Foo bar*' => '**/Foo bar*/**'
      //   '! *zone*' => '!**/*zone*/**'
      //   '{ Foo bar , *zone }' => '**/{Foo bar,*zone}/**'
      //   '  ! {    Foo bar  , *zone }    ' => '!**/{Foo bar,*zone}/**'
      .map(item => item
        .trim() // remove any leading or trailing whitespace
        .replace(/\s*([!(){},|/])\s*/g, '$1') // remove any whitespace around the following special characters: !(){},|/
        .replace(/(!?)(.*)/, '$1**/$2/**') // add **/ and /** glob patterns around the whole string
      )

    // console.debug('getLayerFilterArray', capabilityOptions.layerFilter, layerFilterArray)

    return layerFilterArray
  }

  static hasLayerFilter (capabilityOptions: ConfigLayerCapabilityOptions) {
    return !!capabilityOptions.layerFilter
  }

  static layerMatchesFilter (configObj: ConfigLayerOptions, layerFilterArray: string[]) {
    const { layerPathArray, title, titleid } = configObj

    // Create string from layer path array (mainly for layertree layers)
    const layerFullPathString = (layerPathArray || [title]).join('/')

    // The matching library treats slashes as file paths and in order to match properly,
    // we add slashes to the start and end of the the layer full path string
    const matchLayerFullPathString = `/${layerFullPathString}/`

    // console.debug('layerMatchesFilter', titleid, layerFilterArray, matchLayerFullPathString)

    const matchOptions = {
      nocase: true // do case insensitive matching
    }

    // Do the actual matching using minimatch (https://github.com/isaacs/minimatch)
    const isMatch = layerFilterArray.every(filter => minimatch(matchLayerFullPathString, filter, matchOptions))

    if (!isMatch) {
      // console.debug('layerMatchesFilter - no match', titleid, matchLayerFullPathString, layerFilterArray)
      return false
    }

    return true
  }

  static postProcessLayers (capabilityOptions: ConfigLayerCapabilityOptions, layerConfs: any[]) {
    if (capabilityOptions.sortLayers) {
      this.sortLayers(layerConfs)
    }

    return layerConfs
  }

  // Sort layers alphabetically.
  // Note: does not support sorting nested layers
  static sortLayers (layerConfs: any[]) {
    layerConfs.sort((confA, confB) => {
      if (confA.title < confB.title) {
        return -1
      }

      if (confA.title > confB.title) {
        return 1
      }

      return 0
    })
  }
}
